import { render } from "./about-us.vue?vue&type=template&id=4c2060df"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"

import "./about-us.vue?vue&type=style&index=0&id=4c2060df&lang=css"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__